// extracted by mini-css-extract-plugin
export default {"sidebar":"LeftSidebar_sidebar__ooru1"};